import { useQuery } from '@tanstack/react-query';
import { getResolutionOptionsQueryFn } from '../graphql/query/getResolutionOptions';
import { QUERIES } from '../utils/constants';
import { useWorkflow } from '../workflow/hooks';
import { generateQueryKey } from '../utils/queries';
import { useErrorHandler } from '../utils/handleErrorCodes';

export const useItemResolutions = (itemId?: string) => {
  if (!itemId) throw new Error('Cannot resolve without item id');

  const { config, data: workflowData, order } = useWorkflow();
  const handleErrorCodes = useErrorHandler();

  const queryKey = generateQueryKey(QUERIES.GET_RESOLUTION_OPTIONS, {
    currentItemId: itemId,
    taskIds: ['reason'],
    workflowConfig: config,
    workflowData,
  });

  const { isLoading, data } = useQuery({
    retry: false,
    enabled: Boolean(workflowData && order && itemId),
    queryKey: [...queryKey],
    queryFn: async () => {
      try {
        return await getResolutionOptionsQueryFn({
          workflowData,
          order,
          itemId,
        });
      } catch (error: unknown) {
        handleErrorCodes(error);
        throw error;
      }
    },
  });

  return {
    isLoading,
    resolutionOptions: data?.resolutionOptions,
  };
};
